/**
 * Возвращает длительность анимации в зависимости от заданной высоты, чтобы предотвратить
 * слишком резкий скачок контента
 * @see {@link https://www.wolframalpha.com/input/?i=%284+%2B+15+*+%28x+%2F+36+%29+**+0.25+%2B+%28x+%2F+36%29+%2F+5%29+*+10}
 * @param height
 * @returns {number} duration
 */
export const getAutoHeightDuration = height => {
  if (!height) {
    return 0;
  }
  const constant = height / 36;
  return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
};